import { $http } from "@/assets/js/appFunc";
/* eslint-disable */
/* PROCESS INSPECTOR */

export const changeInstanceName = (context, data) => {
    const newName = `?newName=${data.newName}`;
    const req = {
        type: "GET",
        url: `/engine/api/processInspector/${data.processInstanceId}/rename${newName}`
    };
    return $http(req, true);
};

export const archiveInstance = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/list/archive",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const appImages = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/list/app/pics",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const teminateInstance = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/terminate",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const searchProcesses = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/search",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
                context.commit("setProcesses", data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const getApiDetails = (context, data) => {
    const req = {
        type: "POST",
        url: "/audit/integration/search",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getComments = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/search/comments",
        data
    };
    return $http(req, true);
};

export const deleteComment = (context, data) => {
    const req = {
        type: "DELETE",
        url: `/engine/api/processInspector/comments/${data.auditId}?processInstanceId=${data.processInstanceId}`
    };
    return $http(req, true);
};

export const getApiRequestResponse = (context, data) => {
    const req = {
        type: "GET",
        url: `/audit/integration/${data}`
    };
    return $http(req, true);
};

export const getBlockchainDetails = (context, data) => {
    const req = {
        type: "POST",
        url: "/audit/blockchain/search",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getDocsDetails = (context, data) => {
    const req = {
        type: "POST",
        url: "/data/attachment/search",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getMessagesDetails = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/search/notifications",
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getMessageSummary = (context, notificationAuditId) => {
    const req = {
        type: "GET",
        url: `/engine/api/processInspector/notification/summary/${notificationAuditId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const deleteNotification = (context, notificationId) => {
    const req = {
        type: "DELETE",
        url: `/engine/api/processInspector/notifications/${notificationId}`
    };
    return $http(req, true).then(
        data => data,
        error => error
    );
};

export const downloadAllDocs = (context, data) => {
    const req = {
        type: "POST",
        url: "/data/attachment/download/attachments/list",
        data,
        responseType: "blob"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getProcessInspectorInformation = (context, processInspectorId) => {
    const req = {
        type: "GET",
        url: `/engine/api/processInstance/${processInspectorId}/summary`
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                context.commit("setProcessInspectorById", data);
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};
export const getDataModelInformation = (context, processInspectorId) => {
    const req = {
        type: "GET",
        url: `/engine/api/processInspector/data/processInstance/${processInspectorId}`
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const deleteDataValues = (context, processInstanceId) => {
    const req = {
        type: "DELETE",
        url: `/engine/api/processInspector/data/${processInstanceId}`
    };
    return $http(req, true);
};

export const anonymizeInstance = (context, processInstanceId) => {
    const req = {
        type: "POST",
        url: `/engine/api/processInspector/data/processInstance/${processInstanceId}/anonymize`
    };
    return $http(req, true);
};

export const deleteDataAudit = (context, processInstance) => {
    const req = {
        type: "DELETE",
        url: `/engine/api/internal/auditTrail/by-instance/${processInstance}/dataModel`
    };
    return $http(req, true);
};

export const deleteDocumentPI = (context, data) => {
    const req = {
        type: "DELETE",
        url: `/data/audit/attachment/${data.attachmentId}?processInstanceId=${data.processInstanceId}`
    };
    return $http(req, true);
};

export const getDownloadLog = (context, data) => {
    const params = {
        type: "POST",
        url: "/log/esLogs/allLogs/download",
        data,
        responseType: "arraybuffer",
        headers: {
            "Content-type": "application/json;charset=UTF-8",
            Accept: "application/octet-stream"
        }
    };

    return $http(params, true).then(
        data => {
            const url = window.URL.createObjectURL(new Blob([data.data], { type: "application/octet-stream" }));
            const link = document.createElement("a");
            link.href = url;
            link.download = data.headers["content-disposition"].split("=")[1];
            document.body.appendChild(link);
            link.click();
        },
        error => error
    );
};

export const getViewLogs = (context, processInstanceId) => {
    const req = {
        type: "GET",
        url: `/log/esLogs/getLogsURL/${processInstanceId}`
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const eventType = (context, payload) => {
    const req = {
        type: "POST",
        url: `/engine/api/auditTrail/processInspector/action/${payload.instanceID}/${payload.actionType}`
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const retryProcess = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/list/retry",
        data
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const retryProcessModal = (context, processInstanceId) => {
    const req = {
        type: "POST",
        url: `/engine/api/processInspector/retry/${processInstanceId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const deleteRequestResponseBlockchainModal = (context, { id, instanceID, type }) => {
    const req = {
        type: "DELETE",
        url: `/audit/blockchain/${id}/${type}?processInstanceId=${instanceID}`
    };
    return $http(req, true);
};

export const deleteRequestResponseApiModal = (context, { id, instanceID, type }) => {
    const req = {
        type: "DELETE",
        url: `/audit/integration/${id}/${type}?processInstanceId=${instanceID}`
    };
    return $http(req, true);
};

export const deleteInstanceAction = (context, data) => {
    const req = {
        type: "DELETE",
        url: `/engine/api/processInspector/delete/processInstance/${data.processInstanceId}`
    };
    return $http(req, true);
};

export const dataModelSave = (contex, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/data/save",
        data
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            }
        ).catch(error => {
            console.log(error);
            if (error.response.status === 406) {
                resolve(error);
            } else {
                reject(error);
                console.log(error);
            }
        });
    });
};

export const actSaveRetention = (context, payload) => {
    const processDefinitionId = context.state.processInspectorById.processInstanceId;
    return $http({
        type: "POST",
        url: `/engine/api/processInstance/${processDefinitionId}/retention`,
        data: payload
    }, true);
};

export const actSaveDeletion = (context, payload) => {
    const processDefinitionId = context.state.processInspectorById.processInstanceId;
    return $http({
        type: "POST",
        url: `/engine/api/processInstance/${processDefinitionId}/deletion`,
        headers: { "Content-Type": "application/json" },
        data: payload
    }, true);
};
export const deleteInstances = (context, payload) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/bulk-delete/processInstances",
        data: payload
    };
    return $http(req, true);
};

export const getRichTextList = (context, payload) => {
    const req = {
        type: "POST",
        url: "/engine/api/processInspector/list/richtext",
        data: payload
    };
    return $http(req, true);
};

export const getRichTextDetails = (context, payload) => {
    const req = {
        type: "GET",
        url: `/engine/api/processInspector/richtext/${payload}/details`
    };
    return $http(req, true);
};

export const deleteRichText = (context, payload) => {
    const req = {
        type: "DELETE",
        url: `/engine/api/processInspector/richText/${payload}`
    };
    return $http(req, true);
};


